import React from 'react';
import { Group, Text, Loader, Tooltip, ActionIcon } from '@mantine/core';
import { IconCloud, IconCloudCheck } from '@tabler/icons-react';

const AutosaveIndicator = ({ isSaving, isSaved }) => {
  if (isSaving) {
    return (
      <Tooltip label="Saving..." position="bottom">
        <Group spacing="xs">
          <Loader size="sm" color="blue" />
          <Text size="sm" color="blue">Saving...</Text>
        </Group>
      </Tooltip>
    );
  }

  if (isSaved) {
    return (
      <Tooltip label="Auto-saved" position="bottom">
        <Group spacing="xs">
          <IconCloudCheck size={16} color="green" />
          <Text size="sm" color="green">Saved</Text>
        </Group>
      </Tooltip>
    );
  }

  return (
    <Tooltip label="Not saved" position="bottom">
      <ActionIcon size="sm" variant="subtle" color="gray">
        <IconCloud size={16} />
      </ActionIcon>
    </Tooltip>
  );
};

export default AutosaveIndicator;